var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c("div", { class: _vm.$style.logo }, [
            _vm.account.logo
              ? _c("img", { attrs: { src: _vm.logo, alt: "Account Logo" } })
              : _c("div", [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("business"),
                  ]),
                ]),
          ]),
          _c("div", [
            _c("div", { class: _vm.$style.title }, [
              _vm._v(" Assign an account manager "),
            ]),
            _c("div", { class: _vm.$style.subTitle }, [
              _vm._v(" to " + _vm._s(_vm.account.name) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.users },
            _vm._l(_vm.sortedUsers, function (user) {
              return _c(
                "div",
                {
                  key: user.id,
                  class: {
                    [_vm.$style.user]: true,
                    [_vm.$style.selected]: _vm.selected(user),
                    [_vm.$style.originallySelected]:
                      _vm.originallySelected(user),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setAgent(user.id)
                    },
                  },
                },
                [
                  _c("rb-radio", {
                    class: _vm.$style.radio,
                    attrs: { option: user.id },
                    model: {
                      value: _vm.primaryAgent,
                      callback: function ($$v) {
                        _vm.primaryAgent = $$v
                      },
                      expression: "primaryAgent",
                    },
                  }),
                  _c("span", [_vm._v(" " + _vm._s(user.fullName) + " ")]),
                  user.accountsManaged.length > 0
                    ? _c("div", [
                        _vm._v(
                          " Managing " +
                            _vm._s(user.accountsManaged.length) +
                            " " +
                            _vm._s(
                              user.accountsManaged.length !== 1
                                ? "Companies"
                                : "Company"
                            ) +
                            " "
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "rbTooltip simple",
                            attrs: { tooltip: "placement:top-start" },
                          },
                          [
                            _c("b", [_vm._v("Accounts Managed")]),
                            _c("br"),
                            _vm._l(
                              user.accountsManaged,
                              function ({ accountDetails, id }) {
                                return _c("div", { key: id }, [
                                  _vm._v(
                                    " " + _vm._s(accountDetails.name) + " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                      ])
                    : _c("div", { class: _vm.$style.unAssigned }, [
                        _vm._v(" Not Assigned "),
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("warning"),
                        ]),
                      ]),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: { click: _vm.cancel },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("account_circle"),
            ]),
            _vm._v(" Apply Changes "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }